
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AgentActionLabel',
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: false,
      default: 'text-vanilla-400'
    }
  }
})
